import React, { useState, useEffect } from 'react';

import 'rc-datepicker/lib/style.css';

import { SELECT_VAL_TYPE_INT, SELECT_VAL_TYPE_STRING } from '../../../Res/BaseInput';
import { BaseSearchBox } from '../../../Res/BaseSearch';
import { MultiAutoSelect, SearchAutoSelect, SearchBr, SearchInput, SearchSelect } from '../../../../../item/ItemSearch';
import { action_type_arr, action_type_code_arr, GAME_ACTIONLIST_TYPE_PITCH, inning_half_arr, KEY_ACTIONLIST_ACTION_CODE, KEY_ACTIONLIST_ACTION_TYPE, KEY_ACTIONLIST_INNING, KEY_ACTIONLIST_INNING_HALF, KEY_ACTIONLIST_INNING_STRING, KEY_ACTIONLIST_PITCHCODE_STRING, KEY_ACTIONLIST_PITCH_RESULTCODE, KEY_ACTIONLIST_PITCH_RESULTCODE_STRING, KEY_ACTIONLIST_PITCH_TYPE, KEY_ACTIONLIST_PLAYERNAME, KEY_ACTIONLIST_PLAYERNAME_STRING, KEY_ACTIONLIST_RESULTCODE, KEY_ACTIONLIST_RESULTCODE_STRING, KEY_ACTIONLIST_TYPECODE_STRING, pitch_result_arr, pitch_type_arr, ReqAction2ActionList } from '../../../../../item/MyStat/actionList';
import { ReqGameList } from '../../../../../item/MyStat/ItemGame';
import { result_code_arr } from '../../../../../item/MyStat/resultCode';

export function ActionListSearch2({ id, items, playerItems=[], action }) {
    const [tokenId, setTokenId] = useState("")


    const [inning, set_inning] = useState("")
    const [inning_half, set_inning_half] = useState("")
    const [pitch_result_code, set_pitch_result_code] = useState("")
    const [pitch_type, set_pitch_type] = useState("")
    const [player_name, set_player_name] = useState("")
    const [result_code, set_result_code] = useState("")
    const [actionSearchItems, setActionSearchItems] = useState([])

    const [inning_arr, set_inning_arr] = useState([])
    const [action_code_arr, set_action_code_arr] = useState([])

    const [player_arr, set_player_arr] = useState([])

    useEffect(() => {
        var inn_arr = []
        for (var i = 1; i <= 15; i++) {

            inn_arr.push({ val: i, name: i })
        }
        set_inning_arr(inn_arr)
    }, [])

    // useEffect(() => {
    //     if (pitch_result_code !== "") {
    //         var filterEmpty = action_type_code_arr.filter((item) => {
    //             return item.key === pitch_result_code;
    //         });
    //         try {
    //             console.log("filterEmpty")
    //             console.log(filterEmpty[0].arr)
    //             set_action_code_arr(filterEmpty[0].arr)
    //         } catch (e) {
    //             set_action_code_arr([])
    //         }
    //     } else {
    //         set_action_code_arr([])
    //     }
    //     // set_action_code_arr(action_type_code_arr[action_type])
    // }, [pitch_result_code])


    useEffect(() => {
        if (playerItems.length !== 0) {
            set_player_arr(playerItems)
        }
        // console.log(playerItems)
    }, [playerItems])

    useEffect(() => {
        var searchItems = [
            [
                new SearchSelect({
                    key: KEY_ACTIONLIST_INNING,
                    val: inning,
                    defaultVal: "",
                    valType: SELECT_VAL_TYPE_INT,
                    title: KEY_ACTIONLIST_INNING_STRING,
                    col: 3,
                    attr: inning_arr,
                    hasBlank: true,
                    blankOption: '全部'
                }),
                new SearchSelect({
                    key: KEY_ACTIONLIST_PITCH_RESULTCODE,
                    val: pitch_result_code,
                    defaultVal: "",
                    valType: SELECT_VAL_TYPE_STRING,
                    title: KEY_ACTIONLIST_PITCH_RESULTCODE_STRING,
                    col: 3,
                    attr: pitch_result_arr,
                    hasBlank: true,
                    blankOption: '全部',
                }),
                new SearchAutoSelect({
                    title: KEY_ACTIONLIST_PLAYERNAME_STRING,
                    key: KEY_ACTIONLIST_PLAYERNAME,
                    val: player_name,
                    defaultVal: '',
                    valType: KEY_ACTIONLIST_PLAYERNAME_STRING,
                    col: 3,
                    attr: player_arr,
                    hasBlank: true,
                    blankOption: '全部',
                    blankVal:"",
                    n:"name",
                    v:"name"
                }),
                new MultiAutoSelect({
                    title: KEY_ACTIONLIST_RESULTCODE_STRING,
                    key: KEY_ACTIONLIST_RESULTCODE,
                    val: result_code,
                    defaultVal: '',
                    valType: KEY_ACTIONLIST_PLAYERNAME_STRING,
                    col: 3,
                    attr: result_code_arr,
                    hasBlank: true,
                    blankOption: '全部',
                    blankVal:"",
                    n:"name",
                    v:"val"
                }),
                new SearchBr(),
                new SearchSelect({
                    key: KEY_ACTIONLIST_INNING_HALF,
                    val: inning_half,
                    defaultVal: '',
                    valType: SELECT_VAL_TYPE_INT,
                    col: 3,
                    attr: inning_half_arr,
                    hasBlank: true,
                    blankOption: '全部',
                }),
                new SearchSelect({
                    key: KEY_ACTIONLIST_PITCH_TYPE,
                    val: pitch_type,
                    defaultVal: '',
                    valType: SELECT_VAL_TYPE_STRING,
                    col: 3,
                    attr: pitch_type_arr,
                    hasBlank: true,
                    blankOption: '全部',
                }),
            ],
            // new SearchBrLine()
        ]
        setActionSearchItems(searchItems)
    }, [inning_arr, action_code_arr, inning, inning_half, pitch_result_code, pitch_type, player_name, player_arr, result_code])


    const onChange = (key, val) => {
        console.log(key)
        console.log(val)
        switch (key) {
            case KEY_ACTIONLIST_INNING:
                set_inning(val)
                break;
            case KEY_ACTIONLIST_INNING_HALF:
                set_inning_half(val)
                break;
            case KEY_ACTIONLIST_PITCH_RESULTCODE:
                set_pitch_result_code(val)
                break;
            case KEY_ACTIONLIST_PITCH_TYPE:
                set_pitch_type(val)
                break;
            case KEY_ACTIONLIST_PLAYERNAME:
                set_player_name(val)
                break;
            case KEY_ACTIONLIST_RESULTCODE:
                set_result_code(val)
                break;
            default:
                break;
        }
    }

    return (
        <BaseSearchBox action={action} items={actionSearchItems} onChange={onChange} />
    )
}

